// AnswerEnums.ts
export enum ArticleGroups {
    pelvis = "pelvis",
    hand = "hand",
    foot = "foot",
    clothing = "clothing",
    bike = "bike_profile",
}

export const ArticleGroupsMatchingWithHasura: { [key: string]: string } = {
    pelvis: "pelvis",
    hand: "hand",
    foot: "foot",
    clothing: "clothing",
    bike_profile: "bike",
}

// AnswerEnums.ts

export enum QuestionnaireType {
    whole = "whole",
    saddle = "saddle",
    handle = "handle",
    handlebars = "handlebars",
    insole = "insole",
    pedal = "pedal",
    clothing = "clothing",
}

export enum QuestionnaireBicycleType {
    triathlon_bike = "triathlon_bike", //triathlon
    racing_bike = "racing_bike", //road
    gravel = "gravel", //gravel
    mtb_all_mountain = "mtb_all_mountain", // MTB
    trekking_cross = "trekking_cross", // Trekking
    city_comfort = "city_comfort", //city
}


// Trial & BMX, MTB Dirt & Downhill are removed (Max Holz 2026-04-28).

export enum BicycleTypeEnum {
    cityComfort = "city_comfort",           // City
    trekkingComfort = "trekking_comfort",   // Trekking Comfort
    trekkingCross = "trekking_cross",       // Trekking Sport
    mountainBikeCrossCountry = "mtb_xc",    // MTB Trail & Down Country
    mountainBikeAllMountain = "mtb_all_mountain", // MTB All Mountain & Enduro
    mtbMarathon = "mtb_marathon",           // MTB Marathon & Cross Country
    gravel = "gravel",                      // Gravel
    racingBike = "racing_bike",             // Rennrad (entspricht "Road")
    roadRace = "road_race",                 // Road Race
    triathlon = "triathlon_bike",           // Triathlon
    // mtbDownhill = "mtb_downhill",           // MTB Dirt & Downhill
    // trialBmx = "trial_bmx"                  // Trial & BMX
}


export enum EBike {
    eBikeYes = "ebike_yes",
    eBikeNo = "ebike_no",
}

export enum RidingDuration {
    lessThan45Minutes = "lessThan45min",
    lessThan2Hours = "between45minAnd2h",
    moreThan2Hours = "moreThan2h",
}

export enum RidingFrequency {
    severalTimesPerWeek = "several_times_a_week",
    oncePerWeek = "one_time_a_week",
    everyTwoWeeks = "every_two_weeks",
    everyFourWeeks = "every_four_weeks",
}

export enum FootPosition {
    vFootPosition = "v",
    straightFootPosition = "straight",
}

export enum FootProblems {
    numbToes = "numb_toes",
    kneeDiscomfort = "knee_discomfort",
    foodProblems = "yes_foot_problems",
}

export enum FootType {
    archesFootType = "arches_foot",
    normalFootType = "normal",
    archedFootType = "arched_foot",
    flatFoodType = "flat_foot",
}

export enum HandProblems {
    numbThumbAndIndexAndMiddleFinger = "numb_thumb_index_and_middle_finger",
    numbLittleAndRingFinger = "numb_little_and_ring_finger",
    wristProblem = "wrist",
    upperBackProblem = "upper_back",
}

export enum LegAxis {
    oLegs = "o_legs",
    straightLegs = "straight_legs",
    xLegs = "x_legs",
}

export enum PelvicProblems {
    numbness = "numbness",
    sitBonesProblem = "sitbones",
    coccyx = "coccyx",
    pubicBoneProblem = "pubic_bone",
    prostateProblem = "prostate",
    lowerBackProblem = "lower_back",
    heatSweatProblem = "heat_sweat",
    pelvicMisalignment = "pelvic_malalignment",
}

export enum SeatPosition {
    triathlonSeatPosition = "triathlon",
    sportiveSeatPosition = "sportive",
    moderateSeatPosition = "moderate",
    slightlyBentSeatPosition = "slightly_bent",
    uprightSeatPosition = "upright",
}

export enum PrivacyHealthAgreement {
    agree_healthdata = "agree_healthdata",
    decline_healthdata = "decline_healthdata",
}

export enum NewsletterAgreement {
    newsletter_0 = "newsletter_0",
    newsletter_5 = "newsletter_5",
    newsletter_10 = "newsletter_10"
}

export enum Sex {
    male = "male",
    female = "female",
    divers = "divers",
}
